// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2zR6j","content":"GlobalSearch_content__3Gngd"};